import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Input, Select } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { postRepatriationsTransactionsCreateRequestActionCreator } from '../redux/actions/InternalRepatriationsTransactionsCreateActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import DATE_FORMATS from '../../../../../../common/models/constants/dateFormats';
import {
  getImpcsOfSingleInboundOperatorRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
} from '../../../../../../common/selection-criteria/impcs-per-operator/redux/actions/ImpcsOfSingleOperatorActions';
import { getInboundImpcsOfSingleOperator, getLeftPostalOperatorsCodesOnly, getOutboundImpcsOfSingleOperator } from '../../../../../../common/user/redux/selectors/UserDataSelectors';
import {
  getGlobalPresetImpc,
  getGlobalPresetOperator,
} from '../../../../../../common/selection-criteria/global-preset/redux/selectors/GlobalPresetPerAssetTypeSelectors';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

const operators = process.env.relatedOperators;
const relatedOperators = operators.split('|');

class InternalRepatriationsTransactionsCreateDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: props.row.row.comments,
      departureDateTime: moment(props.row.row.departureDateTime).set({ second: 0 }).format('YYYY-MM-DD HH:mm:ss'),
      outboundImpc: this.props.globalImpc.includes(props.row.row.impc) ? props.row.row.impc : 'Select IMPC',
      inboundImpc: props.row.row.impcTo,
      outboundOperator: this.props.globalOperator.includes(props.row.row.operator) ? props.row.row.operator : 'Select Operator',
      inboundOperator: this.props.globalOperator.includes(props.row.row.operator) ? props.row.row.operator : 'Select Operator',
      plannedArrivalDateTime: moment(props.row.row.arrivalDateTime).set({ second: 0 }).format('YYYY-MM-DD HH:mm:ss'),
      quantity: props.row.row.quantity,
      errorQuantity: '',
    };
    this.handleNewOutboundOperator = this.handleNewOutboundOperator.bind(this);
    this.handleNewOutboundIMPC = this.handleNewOutboundIMPC.bind(this);
    this.handleNewInboundOperator = this.handleNewInboundOperator.bind(this);
    this.handleNewInboundIMPC = this.handleNewInboundIMPC.bind(this);
    this.handleQuantity = this.handleQuantity.bind(this);
    this.handleComments = this.handleComments.bind(this);
    this.handleDepartureDate = this.handleDepartureDate.bind(this);
    this.handleArrivalDate = this.handleArrivalDate.bind(this);
    this.confirmCreate = this.confirmCreate.bind(this);
    this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, props.row.row.operator);
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, props.row.row.operator);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.inboundOperator !== prevState.inboundOperator) {
      this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, this.state.inboundOperator);
    }
    if (this.state.outboundOperator !== prevState.outboundOperator) {
      this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, this.state.outboundOperator);
    }
  }

  isFormValid = () => !(this.state.quantity === ''
    || this.state.quantity === undefined
    || (moment(this.state.departureDateTime).isAfter(this.state.plannedArrivalDateTime))
    || this.state.departureDateTime === 'Invalid date'
    || this.state.plannedArrivalDateTime === 'Invalid date'
    || this.state.outboundImpc === 'Select IMPC'
    || this.state.inboundImpc === 'Select IMPC'
    || this.state.errorQuantity === 'Quantity value can not be negative'
    || this.state.outboundOperator === 'Select Operator'
    || this.state.inboundOperator === 'Select Operator'
    || this.state.inboundImpc === undefined)

  handleNewOutboundOperator(selectedOption) {
    this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    if (relatedOperators.includes(selectedOption.value) && relatedOperators.includes(this.state.inboundOperator)) {
      this.setState({
        outboundOperator: selectedOption.value,
        outboundImpc: 'Select IMPC',
      });
    } else {
      this.setState({
        outboundOperator: selectedOption.value,
        inboundOperator: selectedOption.value,
        outboundImpc: 'Select IMPC',
        inboundImpc: 'Select IMPC',
      });
    }
  }

  handleNewOutboundIMPC(selectedOption) {
    this.setState({
      outboundImpc: selectedOption.value,
    });
  }

  handleNewInboundOperator(selectedOption) {
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    if (relatedOperators.includes(selectedOption.value) && relatedOperators.includes(this.state.outboundOperator)) {
      this.setState({
        inboundOperator: selectedOption.value,
        inboundImpc: 'Select IMPC',
      });
    } else {
      this.setState({
        inboundOperator: selectedOption.value,
        outboundOperator: selectedOption.value,
        inboundImpc: 'Select IMPC',
        outboundImpc: 'Select IMPC',
      });
    }
  }

  handleNewInboundIMPC(selectedOption) {
    this.setState({
      inboundImpc: selectedOption.value,
    });
  }

  handleQuantity(e) {
    let error = '';
    if (parseInt(e.target.value, 0) < 0) {
      error = 'Quantity value can not be negative';
    }
    this.setState({
      quantity: e.target.value,
      errorQuantity: error,
    });
  }

  handleComments(e) {
    this.setState({
      description: e.target.value,
    });
  }

  handleDepartureDate(date) {
    this.setState({
      departureDateTime: moment(date).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
    });
  }

  handleArrivalDate(date) {
    this.setState({
      plannedArrivalDateTime: moment(date).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
    });
  }

  mapImpcListToSelectOptions(listToMappedOptions) {
    const mappedList = [];
    listToMappedOptions.map((item) => {
      const impc = {
        label: item,
        value: item,
      };
      return mappedList.push(impc);
    });
    return mappedList;
  }

  async confirmCreate() {
    await this.props.postRepatriationsTransactionsCreateRequestActionCreator(
      this.props.appContext,
      this.state.departureDateTime,
      this.state.description,
      this.state.inboundImpc,
      this.state.inboundOperator,
      this.state.outboundImpc,
      this.state.outboundOperator,
      this.state.plannedArrivalDateTime,
      this.state.quantity,
    );
    this.props.closeDialog();
    this.props.refreshTransactions();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Create Internal Repatriation</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Outbound Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.outboundOperator}
                    placeholder={this.state.outboundOperator}
                    options={this.props.operatorFromOptions}
                    onChange={this.handleNewOutboundOperator}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Outbound IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.outboundImpc}
                    placeholder={this.state.outboundImpc}
                    options={this.mapImpcListToSelectOptions(this.props.impcFromList.filter((item) => item !== this.state.inboundImpc))}
                    onChange={this.handleNewOutboundIMPC}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Inbound Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.inboundOperator}
                    placeholder={this.state.inboundOperator}
                    options={this.props.operatorToOptions}
                    onChange={this.handleNewInboundOperator}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Inbound IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.inboundImpc}
                    placeholder={this.state.inboundImpc}
                    options={this.mapImpcListToSelectOptions(this.props.impcToList.filter((item) => item !== this.state.outboundImpc))}
                    onChange={this.handleNewInboundIMPC}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Description
                </td>
                <td className="selected-impc">
                  <Input
                    value={this.state.description}
                    onChange={this.handleComments}
                    maxLength="40"
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Quantity
                </td>
                <td className="selected-impc">
                  <Input
                    id="quantity"
                    type="number"
                    value={this.state.quantity}
                    onChange={this.handleQuantity}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1 }}
                  />
                  <p style={{ color: 'red' }}>{this.state.errorQuantity}</p>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Departure date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.departureDateTime}
                        strictCompareDates
                        onChange={this.handleDepartureDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Arrival date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.plannedArrivalDateTime}
                        onChange={this.handleArrivalDate}
                        minDate={this.state.departureDateTime}
                        minDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmCreate}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

InternalRepatriationsTransactionsCreateDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  impcToList: PropTypes.arrayOf(PropTypes.string),
  impcFromList: PropTypes.arrayOf(PropTypes.string),
  operatorFromOptions: PropTypes.arrayOf(PropTypes.object),
  operatorToOptions: PropTypes.arrayOf(PropTypes.object),
  postRepatriationsTransactionsCreateRequestActionCreator: PropTypes.func,
  getImpcsOfSingleInboundOperatorRequestActionCreator: PropTypes.func,
  getImpcsOfSingleOutboundOperatorRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  globalOperator: PropTypes.arrayOf(PropTypes.string),
  globalImpc: PropTypes.arrayOf(PropTypes.string),
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    impcToList: getInboundImpcsOfSingleOperator(state),
    impcFromList: getOutboundImpcsOfSingleOperator(state),
    operatorFromOptions: getLeftPostalOperatorsCodesOnly(state),
    operatorToOptions: getLeftPostalOperatorsCodesOnly(state),
    globalOperator: getGlobalPresetOperator(state),
    globalImpc: getGlobalPresetImpc(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postRepatriationsTransactionsCreateRequestActionCreator,
  getImpcsOfSingleInboundOperatorRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InternalRepatriationsTransactionsCreateDialog);
